import validator from 'validator';
import TextInput from './TextInput';
import RadioInput from './RadioInput';
import CheckboxInput from './CheckboxInput';
import SelectInput from './SelectInput';
import SimpleDatePicker from './SimpleDatePicker';
import SimpleGuestCounter from './SimpleGuestCounter';

export {
  TextInput,
  RadioInput,
  CheckboxInput,
  SelectInput,
  SimpleDatePicker,
  SimpleGuestCounter
};

export const ShowError = {
  ALWAYS: true,
  NEVER: false,
  CHANGED: ({ changed }) => changed,
  FOCUSED: ({ focused }) => focused,
  BLURRED: ({ blurred }) => blurred
};

export class InlineTextInput extends TextInput {}
InlineTextInput.defaultProps = Object.assign({}, TextInput.defaultProps, { inline: true });

export class PasswordInput extends TextInput {}
PasswordInput.defaultProps = Object.assign({}, TextInput.defaultProps, { password: true });

export class InlinePasswordInput extends TextInput {}
InlinePasswordInput.defaultProps = Object.assign({}, TextInput.defaultProps, { inline: true, password: true });

const phoneRe = new RegExp('^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?' +
  '(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)' +
  '|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?' +
  '([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})' +
  '(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$');
export class PhoneInput extends TextInput {}
PhoneInput.defaultProps = Object.assign({}, TextInput.defaultProps, {
  placeholder: '(555) 555-1212',
  validator: (value) => !phoneRe.test(value) && 'Please enter a valid phone number.'
});

export class EmailInput extends TextInput {}
EmailInput.defaultProps = Object.assign({}, TextInput.defaultProps, {
  validator: (value) => !validator.isEmail(value) && 'Please enter a valid email.'
});

export class InlineEmailInput extends TextInput {}
InlineEmailInput.defaultProps = Object.assign({}, TextInput.defaultProps, {
  inline: true,
  validator: (value) => !validator.isEmail(value) && 'Please enter a valid email.'
});


export class InlineRadioInput extends RadioInput {}
InlineRadioInput.defaultProps = Object.assign({}, RadioInput.defaultProps, { inline: true });

export class InlineCheckboxInput extends CheckboxInput {}
InlineCheckboxInput.defaultProps = Object.assign({}, CheckboxInput.defaultProps, { inline: true });
